import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { initMetaPixel } from './utils/metaPixel';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-gold/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <OfferSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </main>
      <footer className="bg-charcoal text-cream/40 py-8 text-center text-sm border-t border-white/10" data-id="element-12">
        <p data-id="element-13">
          © 2026 El Protocolo de la Piel de Lujo. Todos los derechos
          reservados.
        </p>
      </footer>
      <RecentPurchaseToast data-id="element-14" />
    </div>;
}